import i18nConfig from 'config/i18n'

export default {
  data() {
    return {
      route: ''
    }
  },
  methods: {
    getPageLinks() {
      let links = i18nConfig.availableLocales.map((key) => {
        return {
          rel: 'alternate',
          hid: 'lang-' + key,
          href: this.getPageAlternateForLocale(key),
          hreflang: key
        }
      })

      links = links.filter((item) => {
        return item.href !== `${process.env.BASE_URL}/`
      })

      if (this.getPageAlternateForLocale('en') !== `${process.env.BASE_URL}/`) {
        links.push({
          rel: 'alternate',
          hid: 'lang-xlang',
          href: this.getPageAlternateForLocale('en'),
          hreflang: 'x-default'
        })
      }

      links.push({
        hid: 'canonical',
        rel: 'canonical',
        href: `${process.env.CANONICAL_URL}${this.$route.path}`
      })

      return links
    },
    getPageLinksFiltered(locale) {
      const linksFiltered = i18nConfig.availableLocales.filter((locale) => { return locale === 'pt-br' })
      let links = linksFiltered.map((key) => {
        return {
          rel: 'alternate',
          hid: 'lang-' + locale,
          href: this.getPageAlternateForLocale(locale),
          hreflang: locale
        }
      })
      links = links.filter((item) => {
        return item.href !== `${process.env.BASE_URL}/`
      })

      links.push({
        hid: 'canonical',
        rel: 'canonical',
        href: `${process.env.CANONICAL_URL}${this.$route.path}`
      })

      return links
    },

    getPageAlternateForLocale(key) {
      return this.$routeResolver(this.route, key, process.env.BASE_URL)
    }
  }
}
